/*
 * @Author: songpan
 * @Date: 2022-03-03 16:49:02
 * @LastEditTime: 2022-03-20 23:15:06
 * @LastEditors: songpan
 * @Description: 列表模块API（样例）
 */

import service from '@/utils/request';
import { CommonListResponseWrapper } from './common';

interface ListItem {
  name: string;
}

export interface CategoryFace {
  deviceCategoryId: number;
  name: string;
  cmsId: null;
  crmId: null;
  parentId: number;
  createTime: null;
  deptId: null;
  tenantId: null;
  orderNumber: null;
}

import { getRequestHeaders } from '@/api/sign';

export const getListAPI = (params: { pageNum: number; pageSize: number }) => {
  const sign = getRequestHeaders(params);
  return service.get<CommonListResponseWrapper<ListItem>>('/list', { ...sign });
};

// H5请求设备大类
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDeviceCategory = (params: any) => {
  const sign = getRequestHeaders(params);
  return service.post<CategoryFace>('/allsales/h5/deviceCategory', { ...sign });
};

// H5请求设备大小
export const getDeviceCategoryMin = (params: { deviceCategoryId: number }) => {
  const sign = getRequestHeaders(params);
  return service.post<CategoryFace>('/allsales/h5/deviceCategoryMin', { ...sign, ...params });
};

//H5请求设备小类
export const getDeviceMode = (params: { deviceCategoryId: number }) => {
  const sign = getRequestHeaders(params);
  return service.post<CategoryFace>('/allsales/h5/mode', { ...sign, ...params });
};

// H5请求设备小类佣金
export const getDeviceCommission = (params: { deviceId: number; deviceNum: number }) => {
  const sign = getRequestHeaders(params);
  return service.post('/allsales/h5/deviceCommission', { ...sign, ...params });
};

// H5推荐人获取验证码
export const getClueSaveSendCode = (params: { phone: string }) => {
  const sign = getRequestHeaders(params);
  return service.post('/allsales/h5/clueSave/sendCode', { ...sign, ...params });
};

// H5获取城市数据
export const getSanyRegionCity = (params: {
  IS_INPUT: {
    CODE: string;
    LEVEL: string;
  };
}) => {
  return service.post('/allsales/h5/province', { ...params });
};

interface ClueSaveFace {
  myUserId?: string;
  accountName: string;
  accountMobile: string;
  referrerMobile: string;
  num: number;
  province: string;
  city: string;
  area: string;
  deviceId: number;
  cityId: string;
  note?: string;
  type: string;
  userId: number;
  categoryFullname: string;
  origin: number;
  verificationCode: string;
}
// h5推荐人提交
export const addClue = (params: ClueSaveFace) => {
  const sign = getRequestHeaders(params);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return service.post<{ msg: string; code: number; data: any }>('/allsales/h5/clueSave', { ...sign, ...params });
};
